import React ,{ ChangeEvent } from "react";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { defaultMST1060_R10Filter, useMST1060_R10Store } from "./Store_MST1060_R10";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

interface Props {
	onEnterKeyDown: () => void;
}

export const SearchSection_MST1060_R10 = (props: Props) => {
	const { onEnterKeyDown } = props;
	const { MST1060_R10Filter, setMST1060_R10Filter } = useMST1060_R10Store();
	const { brandCdList, itemGroupList, itemAccountList } = useCommonCodeStore();
    const { setCodeSearchModalProps } = useUiuxStore();
	const searchTextHandleFoucsId = 'searchText_search';

	// 검색어 입력 핸들러
	const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
		setMST1060_R10Filter({ ...MST1060_R10Filter, searchText: e.target.value });
	};

	const handleBarcodeKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === "Enter") {
			onEnterKeyDown();
		}
	}

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
			category: '품목코드',
			focusId: searchTextHandleFoucsId,
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			extraFilter: () => ({
				itemCd: MST1060_R10Filter.itemCd || '',
				itemNm: MST1060_R10Filter.itemNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: MST1060_R10Filter,
		setEditData: setMST1060_R10Filter,
		defaultData: defaultMST1060_R10Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'MST1060_R10_search'
	});

	return (
		<SearchSectionDoubleForm>
			<SearchDropDownForm
				label="브랜드"
				value={MST1060_R10Filter.brandCd}
				optionList={brandCdList}
				onChangeItem={(selectedItem) => setMST1060_R10Filter({ ...MST1060_R10Filter, brandCd: selectedItem?.minorCd || '' })}
			/>
			<SearchInputForm
				label="바코드"
				value={MST1060_R10Filter.searchText}
				onChange={handleSearchChange}
				onKeyDown={handleBarcodeKeyDown}
			/>

			<SearchDropDownForm
				label="품목그룹"
				value={MST1060_R10Filter.itemGroup}
				optionList={itemGroupList}
				onChangeItem={(selectedItem) => setMST1060_R10Filter({ ...MST1060_R10Filter, itemGroup: selectedItem?.minorCd || '' })}
			/>
			<SearchDropDownForm
				label="품목계정"
				value={MST1060_R10Filter.itemAccount}
				optionList={itemAccountList}
				onChangeItem={(selectedItem) => setMST1060_R10Filter({ ...MST1060_R10Filter, itemAccount: selectedItem?.minorCd || '' })}
			/>
			{/* 품목 검색 */}
			<SearchCodeModalForm
				label="품목코드"
				value={MST1060_R10Filter.itemCd}
				valueLabel={MST1060_R10Filter.itemNm}
				handleFoucsId={searchTextHandleFoucsId}
				onChange={getFieldHandlers('itemCd').onChange}
				onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
				onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
			/>
		</SearchSectionDoubleForm>
	);
};

